import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export let Spacer = styled(Box)(() => ({
    minWidth: '8px',
    maxWidth: '8px'
}));
